import { createEntityAdapter, EntityAdapter } from '@ngrx/entity'
import { NotificationType } from '@adex/shared/models/inside-models/notification'


export const notificationsEntityAdapter: EntityAdapter<NotificationType> = createEntityAdapter()
